import { Box } from '@factorialco/deprecated-design-system'

import { Separator } from 'modules/integrations/components/SyncFooter/Separator'
import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

import { BlockingIssues } from './BlockingIssues'
import { IntegrationSettingsLink } from './IntegrationSettingsLink'
import { LastSync } from './LastSync'

const BASE_STYLES = {
  width: '100%',
  zIndex: '10',
  borderBottomLeftRadius: '14px',
  borderBottomRightRadius: '14px',
  alignItems: 'center',
  flexDirection: 'row',
  gap: '8px',
}

function SyncFooterContent() {
  return (
    <>
      <LastSync />
      <Separator />
      <BlockingIssues />
      <IntegrationSettingsLink />
    </>
  )
}

export const SyncFooter = () => {
  const { syncEnabled } = usePrivateIntegrationsSyncContext()

  if (!syncEnabled) return null

  return (
    <Box
      paddingTop="s8"
      paddingBottom="s12"
      paddingX="s24"
      background="grey100"
      style={BASE_STYLES}
    >
      <SyncFooterContent />
    </Box>
  )
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 *
 * This component maintains backward compatibility with the old opinionated positioning
 * behavior (fixed positioning with specific margins) used in ExpensesDataCollection.
 * New implementations should use the base `SyncFooter` component directly and handle
 * positioning in the parent layout.
 *
 * **Migration Path:**
 * - For Compensations team: ✅ Already migrated - using `SyncFooter` in layout's footer slot
 * - For Expenses team: Please refactor ExpensesDataCollection to use a layout pattern similar
 *   to `CompensationsPayrollRunLayout` (see `frontend/src/modules/compensations/pages/CompensationsPayrollRun/Layout/index.tsx`),
 *   then switch to the base `SyncFooter`
 *
 * **Why deprecated:**
 * The old implementation used fixed positioning with hard-coded margins (position: fixed,
 * marginLeft: -24px, etc.), making it difficult to reuse across different layouts.
 * The new `SyncFooter` is presentation-only, allowing parent components to control positioning.
 *
 * **Example migration:**
 * See how Compensations team uses `SyncFooter` in `CompensationsPayrollRunLayout`:
 * - Layout component accepts a `footer` prop
 * - `SyncFooter` is passed as `footer={<SyncFooter />}`
 * - Layout handles positioning without fixed styles
 *
 * @see frontend/src/modules/compensations/pages/CompensationsPayrollRun/Layout/index.tsx
 * @see frontend/src/modules/compensations/pages/CompensationsPayrollRun/index.tsx (line 459)
 *
 */
export const SyncFooterDeprecated = () => {
  const { syncEnabled } = usePrivateIntegrationsSyncContext()

  if (!syncEnabled) return null

  return (
    <Box
      paddingTop="s8"
      paddingBottom="s12"
      paddingX="s24"
      background="grey100"
      style={{
        ...BASE_STYLES,
        position: 'fixed',
        bottom: '0',
        marginLeft: '-24px',
        marginTop: '-17px',
      }}
    >
      <SyncFooterContent />
    </Box>
  )
}
